import { render, staticRenderFns } from "./StationsNoResults.vue?vue&type=template&id=bdc64516&"
import script from "./StationsNoResults.vue?vue&type=script&lang=js&"
export * from "./StationsNoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports